import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	getAllCategoryTrackingFilters,
	getCategoryTrackingStepsData,
	getCategoryTrackingInfoData,
	updateCategoryTrackingData,
} from "../../queries/apiQueries";
import { SelectPicker, Modal, Button, Input } from "rsuite";
import "./categoryProgressTracker.scss";
import ArrowDownIcon from "@rsuite/icons/ArrowDown";
import CheckIcon from "@rsuite/icons/Check";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import WarningRoundIcon from "@rsuite/icons/WarningRound";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MinusIcon from "@rsuite/icons/Minus";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import { FILTERDATA, TIMELINE, CURRENTVIEW } from "../../utils";
import { appInsights } from "../router";
import MainContent from "../../components/Layouts/MainContent";
import MainHeader from "../../components/Layouts/MainHeader";
import { Loader } from "../../components/common/Loader";

const CategoryProgressTracker = (props: any) => {
	const dispatch = useDispatch<any>();
	const [filtersLoading, setFiltersLoading] = useState(true);
	const [isVisible, setIsVisible] = useState(false);
	const allFilters = useSelector(
		(state: any) => state.CommonReducer.allFilters
	);
	const token = useSelector((state: any) => state.CommonReducer.token);
	const [isLoading, setIsLoading] = useState(true);
	const [filterOptions, updateFilterOptions] = useState<any>({
		l1: new Array<{ l1: string }>(),
		l2: new Array<{ l2: string }>(),
		l3: new Array<{ l3: string }>(),
		manager: new Array<{ manager: string }>(),
	});
	const didMount: any = useRef(false);
	const filtersMount: any = useRef(false);
	const [stepsData, setStepsData] = useState<any>([]);
	const [selectedStep, setSelectedStep] = useState<any>({});
	const [searchParams] = useSearchParams();
	const managerParam = searchParams.get("manager");
	const categoryParam = searchParams.get("category");
	const viewParam = searchParams.get("view");
	const [alert, setAlert] = useState(false);
	const [comment, setComment] = useState("");
	const [warning, setWarning] = useState("");
	const [isRightVisible, setIsRightVisible] = useState(false);
	// Initialize selectedFilters with managerParam if present
	const [selectedFilters, setSelectedFilters] = useState<any>(() => {
		const initialFilters = {
			...allFilters,
			manager: allFilters.manager || [],
		};
		if (managerParam) {
			initialFilters.manager = [managerParam];
		}
		if (categoryParam) {
			initialFilters.l3 = [categoryParam];
		}
		return initialFilters;
	});

	useEffect(() => {
		appInsights.trackPageView({
			name: `Navigate to supplier consolidation by ${localStorage.getItem(
				"name"
			)}`,
		});
		if (token) {
			getFilters();
		}
	}, [token]);

	const getCategoryTrackingSteps = async () => {
		let payload = {
			manager: selectedFilters.manager,
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
		};
		try {
			let res = await dispatch(getCategoryTrackingStepsData(payload));
			let finalData: any = [];
			let modules = [
				"Insights & Validation",
				"Strategy Development",
				"Vendor Engagement",
				"Execution",
				"Value Capture",
			];
			if (res) {
				modules.map((m: any) => {
					let stepList: any = [];
					res.map((item: any) => {
						if (m == item.module) {
							stepList = [...stepList, item];
						}
					});
					finalData.push({
						steps: stepList,
						title: m,
						color:
							m == "Insights & Validation"
								? "#3b60a0"
								: m == "Strategy Development"
								? "#86bc2582"
								: m == "Vendor Engagement"
								? "#18618a"
								: m == "Execution"
								? "#5ec1c8"
								: m == "Value Capture"
								? "#2093d4"
								: "#2093d4",
					});
				});
				console.log(finalData);
				setStepsData(finalData);
			}
		} catch (error) {
			console.log(error);
		}
		setIsLoading(false);
	};

	const updateTrackingData = async (
		selectedItem: any,
		commentFlag: any = null
	) => {
		let payload: any = {
			manager: selectedFilters.manager,
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			step: [selectedItem.step],
			statusInd: selectedItem.statusInd == 0 ? 1 : 2,
		};
		if (commentFlag) {
			payload.comments = comment;
		}
		if (selectedItem.statusInd == 0) {
			payload.startdate = moment.utc().format("YYYY-MM-DD");
		} else if (selectedItem.statusInd == 1 || selectedItem.statusInd == 3) {
			payload.enddate = moment.utc().format("YYYY-MM-DD");
		}
		try {
			let res = await dispatch(updateCategoryTrackingData(payload));
			setComment("");
			if (res.status) {
				let updatedData = JSON.parse(JSON.stringify(stepsData));
				updatedData.map((u: any) => {
					if (u.title == selectedItem.module) {
						u.steps.map((d: any) => {
							if (d.step == selectedItem.step) {
								if (d.statusInd == 0) {
									d.statusInd = 1;
								} else {
									d.statusInd = 2;
								}
							}
						});
					}
				});
				console.log("update", updatedData);
				setStepsData(updatedData);
			}
		} catch (error) {
			console.log(error);
		}
		setIsLoading(false);
	};

	const getCategoryTrackingInfo = async () => {
		let payload = {
			manager: selectedFilters.manager,
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: [],
		};
		try {
			let res = await dispatch(getCategoryTrackingInfoData(payload));
			let finalData: any = [];
			let modules = [
				"Insights & Validation",
				"Strategy Development",
				"Vendor Engagement",
				"Execution",
				"Value Capture",
			];
			if (res) {
				modules.map((m: any) => {
					let stepList: any = [];
					res.map((item: any) => {
						if (m == item.module) {
							stepList = [...stepList, item];
						}
					});
					finalData.push({
						steps: stepList,
						title: m,
						color:
							m == "Insights & Validation"
								? "#3b60a0"
								: m == "Strategy Development"
								? "#86bc2582"
								: m == "Vendor Engagement"
								? "#18618a"
								: m == "Execution"
								? "#5ec1c8"
								: m == "Value Capture"
								? "#2093d4"
								: "#2093d4",
					});
				});
				setStepsData(finalData);
			}
		} catch (error) {
			console.log(error);
		}
		setIsLoading(false);
	};

	/* Filters api call */
	const getFilters = async (
		payload: any = {},
		currentFilter: any = "all",
		fo: any = null
	) => {
		// setFiltersLoading(true);
		let res = await dispatch(getAllCategoryTrackingFilters(payload));
		if (fo) {
			if (currentFilter === "manager") {
				updateFilterOptions({
					...fo,
					l1: [...res.l1],
					l2: [...res.l2],
					l3: [...res.l3],
				});
			} else if (currentFilter === "l1") {
				updateFilterOptions({
					...fo,
					l2: [...res.l2],
					l3: [...res.l3],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...fo,
					l3: [...res.l3],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({ ...fo });
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
				});
			}
		} else {
			if (currentFilter === "manager") {
				updateFilterOptions({
					...filterOptions,
					l1: [...res.l1],
					l2: [...res.l2],
					l3: [...res.l3],
				});
			} else if (currentFilter === "l1") {
				updateFilterOptions({
					...filterOptions,
					l2: [...res.l2],
					l3: [...res.l3],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...filterOptions,
					l3: [...res.l3],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({ ...filterOptions });
			} else {
				updateFilterOptions({
					manager: res.manager,
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
				});
			}
		}
		setIsLoading(false);
		setFiltersLoading(false);
		filtersMount.current = false;
		return res;
	};

	const handleFilterUpdate = (value: any, filter: string) => {
		filtersMount.current = true;
		let x: string = filter;
		if (x == "manager") {
			setSelectedFilters({ ...selectedFilters, l3: [], [x]: [value] });
			selectedFilters[x] = [value];
		} else {
			setSelectedFilters({ ...selectedFilters, [x]: [value] });
			selectedFilters[x] = [value];
		}
	};

	/* Updating filter options based on selection (api) */
	const handleClose = (filter: string) => {
		``;
		if (filter === "manager") {
			setSelectedFilters({ ...selectedFilters, l1: [], l2: [], l3: [] });
			getFilters(
				{ ...selectedFilters, l1: [], l2: [], l3: [] },
				"manager"
			);
			if (selectedFilters.manager.length == 1) {
				getCategoryTrackingInfo();
			}
		} else if (filter === "l1") {
			setSelectedFilters({ ...selectedFilters, l2: [], l3: [] });
			getFilters({ ...selectedFilters, l2: [], l3: [] }, "l1");
			if (selectedFilters.manager.length == 1) {
				getCategoryTrackingInfo();
			}
		} else if (filter === "l2") {
			setSelectedFilters({ ...selectedFilters, l3: [] });
			getFilters({ ...selectedFilters, l3: [] }, "l2");
			if (selectedFilters.manager.length == 1) {
				getCategoryTrackingInfo();
			}
		} else if (filter === "l3") {
			// setIsLoading(true);
			setSelectedFilters({ ...selectedFilters });
			if (
				selectedFilters.manager.length == 1 &&
				selectedFilters.l3.length == 1
			) {
				getCategoryTrackingSteps();
			}
		}
	};

	const handleClear = (filter: string) => {
		if (filter === "l1") {
			setSelectedFilters({
				...selectedFilters,
				l1: [],
				l2: [],
				l3: [],
			});
			getFilters({ ...selectedFilters, l1: [], l2: [], l3: [] }, "l1");
			if (selectedFilters.manager.length == 1) {
				getCategoryTrackingInfo();
			}
		} else if (filter === "l2") {
			setSelectedFilters({
				...selectedFilters,
				l2: [],
				l3: [],
			});
			getFilters({ ...selectedFilters, l2: [], l3: [] }, "l2");
			if (selectedFilters.manager.length == 1) {
				getCategoryTrackingInfo();
			}
		} else if (filter === "l3") {
			setSelectedFilters({
				...selectedFilters,
				l3: [],
			});
			getFilters({ ...selectedFilters, l3: [] }, "l3");
			if (selectedFilters.manager.length == 1) {
				getCategoryTrackingInfo();
			}
		}
	};

	const handleStatusChange = (item: any) => {
		console.log("item", item);
		if (item.statusInd == 1) {
			setSelectedStep(item);
			setAlert(true);
		} else {
			updateTrackingData(item);
		}
	};

	const handleButtonStatus = (item: any) => {
		if (item.moduledependency == 0 && item.stepdependency == 0) {
			return false;
		} else if (item.moduledependency == 0 && item.stepdependency != 0) {
			let flag = false;
			stepsData.map((u: any) => {
				u.steps.map((d: any) => {
					if (d.step == item.stepdependency) {
						if (d.statusInd != 2) {
							flag = true;
						}
					}
				});
			});
			return flag;
		} else if (item.moduledependency != 0 && item.stepdependency == 0) {
			let flag = false;
			stepsData.map((u: any, index: any) => {
				if (item.moduledependency == index + 1) {
					u.steps.map((d: any) => {
						if (d.statusInd != 2) {
							flag = true;
						}
					});
				}
			});
			return flag;
		} else if (item.moduledependency != 0 && item.stepdependency != 0) {
			let moduleFlag = false;
			let stepFlag = false;
			stepsData.map((u: any, index: any) => {
				if (item.moduledependency == index + 1) {
					u.steps.map((d: any) => {
						if (d.statusInd != 2) {
							moduleFlag = true;
						}
					});
				}
			});
			stepsData.map((u: any) => {
				u.steps.map((d: any) => {
					if (d.step == item.stepdependency) {
						if (d.statusInd != 2) {
							stepFlag = true;
						}
					}
				});
			});
			if (!moduleFlag && !stepFlag) {
				return false;
			} else {
				return true;
			}
		}
	};

	const handleAlertClose = () => {
		setAlert(false);
		setComment("");
		setWarning("");
	};

	const handleAlertConfirmClick = () => {
		const warn = validate(comment);
		setWarning(warn);
		if (!warn) {
			updateTrackingData(selectedStep, "complete");
			setAlert(false);
		}
	};

	const validate = (text: any) => {
		if (text.length < 10) {
			return `Please enter at least 10 characters.`;
		}
		if (text.length > 100) {
			return `Please enter no more than 100 characters.`;
		}
		return "";
	};

	const handleChange = (val: any) => {
		setComment(val);
		if (val.length > 10 && val.length < 100) {
			setWarning("");
		}
	};

	useEffect(() => {
		if (managerParam || categoryParam) {
			setSelectedFilters((prev: any) => ({
				...prev,
				...(managerParam && { manager: [managerParam] }),
				...(categoryParam && { l3: [categoryParam] }),
			}));
		}
	}, [managerParam, categoryParam]);

	useEffect(() => {
		if (viewParam == "manager") {
			if (selectedFilters.manager.length > 0) {
				getCategoryTrackingInfo();
			}
			setSelectedFilters({ ...selectedFilters, l3: [] });
		} else if (viewParam == "category") {
			if (
				selectedFilters.manager.length > 0 &&
				selectedFilters.l3.length > 0
			) {
				getCategoryTrackingSteps();
			}
		}
	}, [viewParam]);

	useEffect(() => {
		if (token) {
			if (!didMount.current) {
				setIsLoading(true);
				getFilters().then((options: any) => {
					const currentFilters = {
						...selectedFilters,
						manager: managerParam
							? [managerParam]
							: selectedFilters.manager,
						// l3: categoryParam ? [categoryParam] : selectedFilters.l3
						l3: [],
					};
					if (currentFilters.manager.length > 0) {
						getFilters(currentFilters, "manager", options).then(
							() => {
								// if (currentFilters.l3.length > 0) {
								if (categoryParam) {
									getCategoryTrackingSteps();
								} else if (currentFilters.manager.length > 0) {
									getCategoryTrackingInfo();
								}
							}
						);
					} else {
						if (currentFilters.l3.length > 0) {
							getFilters(currentFilters, "l3", options);
						} else if (currentFilters.l2.length > 0) {
							getFilters(currentFilters, "l2", options);
						} else if (currentFilters.l1.length > 0) {
							getFilters(currentFilters, "l1", options);
						}
					}
				});
				didMount.current = true;
			} else {
				// props.onFilterChange(selectedFilters);
			}
		}
	}, [managerParam, categoryParam]);

	return isLoading ? (
		<Loader />
	) : (
		<>
			<div className="supplier-consolidation-container w-full">
				<MainHeader
					onVisibilityChange={setIsVisible}
					isRightVisible={isRightVisible}
					setIsRightVisible={setIsRightVisible}
					topContent={
						<div className="flex justify-between items-center w-full">
							<div className="text-left pageline">
								<span className="pagelinestart textNormal">
									Execution Tracking
								</span>{" "}
								<span className="pagelineslash textNormal">
									/
								</span>{" "}
								<span className="pagelinesub textNormal">
									{viewParam == 'manager' ? `Manager's Dashboard`: `Category Status Inputs`}
								</span>
							</div>
						</div>
					}
					bottomContent={
						<>
							<div className="sub-heading-text font-bold flex flex-col items-start">
								<span className="filterHead textNormal">
									Category Manager
								</span>
								<SelectPicker
									data={
										filterOptions["manager"]?.length
											? filterOptions["manager"]
											: []
									}
									labelKey={"manager"}
									valueKey={"manager"}
									value={
										selectedFilters["manager"]
											? selectedFilters["manager"][0]
											: []
									}
									onClose={() =>
										filtersMount.current
											? handleClose("manager")
											: ""
									}
									onChange={(value: any) => {
										handleFilterUpdate(value, "manager");
									}}
									cleanable={false}
								/>
							</div>
							{["l1", "l2", "l3"].map(
								(filterEntity: string, index: number) => {
									return (
										<div className="sub-heading-text font-bold flex flex-col items-start">
											<span className="filterHead">
												{filterEntity}
											</span>
											<SelectPicker
												data={
													filterOptions[filterEntity]
														.length
														? filterOptions[
																filterEntity
														  ]
														: []
												}
												key={filterEntity}
												labelKey={
													filterEntity == "supplier"
														? "vendor"
														: filterEntity
												}
												valueKey={
													filterEntity == "supplier"
														? "vendor"
														: filterEntity
												}
												placement={
													filterEntity == "l3"
														? "bottomEnd"
														: "bottomStart"
												}
												value={
													selectedFilters[
														filterEntity
													]?.length > 0
														? selectedFilters[
																filterEntity
														  ][0]
														: null
												}
												onClose={() =>
													filtersMount.current
														? handleClose(
																filterEntity
														  )
														: ""
												}
												onClean={() => {
													handleClear(filterEntity);
												}}
												onChange={(value: any) => {
													handleFilterUpdate(
														value,
														filterEntity
													);
												}}
												loading={filtersLoading}
											/>
										</div>
									);
								}
							)}
						</>
					}
				></MainHeader>
				<MainContent isVisible={isVisible} fullHeight={true}>
					<div className="contentBox flex flex-col justify-start overflow-x-auto h-[95%] w-[100%]">
						{(selectedFilters?.manager?.length > 0 &&
							viewParam == "manager") ||
						(selectedFilters?.manager?.length > 0 && !viewParam) ||
						(selectedFilters?.manager?.length > 0 &&
							selectedFilters?.l3?.length > 0 &&
							viewParam == "category") ? (
							<div className="category-steps-container">
								{stepsData.map((section: any, index: any) => (
									<div
										key={index}
										className="step-column"
										style={{
											borderColor: section.color,
										}}
									>
										<div
											className="column-header mr-[2vh]"
											style={{
												width: "100%",
												display: "flex",
											}}
										>
											<div
												className="flex w-full ml-[1vh]"
												style={{
													backgroundColor:
														section.color,
												}}
											>
												<div
													style={{
														width: 0,
														height: 0,
														borderTop:
															"2.5vh solid transparent",
														borderBottom:
															"2.5vh solid transparent",
														borderRight:
															"0 solid transparent",
														borderLeft: `2.2vh solid ${
															section.title ==
															"Insights & Validation"
																? section.color
																: "white"
														}`,
													}}
												></div>
												<span
													style={{
														width: "100%",
														height: "2vh",
														padding: "1vh",
													}}
													className="textNormal"
												>
													{section.title}
												</span>
											</div>
											<div
												style={{
													width: 0,
													height: 0,
													borderTop:
														"2.5vh solid transparent",
													borderBottom:
														"2.5vh solid transparent",
													borderRight:
														"0 solid transparent",
													borderLeft: `2.2vh solid ${section.color}`,
												}}
											></div>
										</div>
										{/* chart flow div */}
										<div className="w-full flex h-[2vh]">
											<div
												className={`w-[50%] ${
													index != 0
														? "dummyTopBorder"
														: ""
												}`}
											></div>
											<div
												className={`w-[50%] ${
													index != 4
														? "dummyRightBorder"
														: ""
												}`}
											></div>
										</div>
										{/* chart flow div */}
										{index != 0 && (
											<div className="w-[100%] h-[0] flex">
												<div className="w-[49%]"></div>
												<ArrowDownIcon
													color="black"
													className="mt-[-2.2vh] ml-[-1.4vh] text-[3.5vh]"
												/>
											</div>
										)}
										<div
											className={`flex flex-col ${
												index != 4
													? "step-box-container"
													: ""
											}`}
										>
											{section.steps.map(
												(step: any, idx: any) => (
													<>
														<div
															key={idx}
															className="step-box"
														>
															<div className="step-header">
																<div className="step-number textSmall">
																	{step.step}
																</div>
																<div className="step-text textSmall">
																	{
																		step.details
																	}
																</div>
																<div className="step-icon">
																	{/* {step.icon} */}
																	{step.statusInd ==
																		2 && (
																		<CheckIcon
																			style={{
																				background:
																					"green",
																				width: "3vh",
																				height: "3vh",
																				padding:
																					".5vh",
																				borderRadius:
																					"2vh",
																			}}
																		/>
																	)}
																	{step.statusInd ==
																		1 && (
																		<PlayArrowOutlinedIcon
																			style={{
																				background:
																					"orange",
																				width: "3vh",
																				height: "3vh",
																				padding:
																					".5vh",
																				borderRadius:
																					"2vh",
																			}}
																		/>
																	)}
																	{step.statusInd ==
																		3 && (
																		<CloseOutlinedIcon
																			style={{
																				background:
																					"red",
																				width: "3vh",
																				height: "3vh",
																				padding:
																					".5vh",
																				borderRadius:
																					"2vh",
																			}}
																		/>
																	)}
																	{step.statusInd ==
																		0 && (
																		<MinusIcon
																			style={{
																				background:
																					"gray",
																				width: "3vh",
																				height: "3vh",
																				padding:
																					".5vh",
																				borderRadius:
																					"2vh",
																			}}
																		/>
																	)}
																</div>
															</div>
															{selectedFilters?.l3
																?.length > 0 ? (
																(step?.statusInd ==
																	1 ||
																	step?.statusInd ==
																		0 ||
																	step?.statusInd ==
																		3) && (
																	<div className="next-step-button opacity-[.8]">
																		<button
																			className="w-fit textSmall"
																			style={{
																				color: "black",
																				borderColor:
																					step.statusInd ==
																					0
																						? "orange"
																						: "gray",
																			}}
																			onClick={() => {
																				handleStatusChange(
																					step
																				);
																			}}
																			disabled={handleButtonStatus(
																				step
																			)}
																		>
																			{step.statusInd ==
																			0
																				? `Move to In progress`
																				: "Mark as completed"}
																			{step.statusInd ==
																				0 && (
																				<PlayArrowOutlinedIcon
																					style={{
																						background:
																							"orange",
																						marginLeft:
																							"1vh",
																						color: "white",
																						width: "3vh",
																						height: "3vh",
																						padding:
																							".5vh",
																						borderRadius:
																							"2vh",
																					}}
																				/>
																			)}
																			
																		</button>
																	</div>
																)
															) : (
																<div className="info-data">
																	<span
																		style={{
																			color: "green",
																		}}
																		className="textSmall"
																	>
																		{
																			step[
																				"2"
																			]
																		}
																	</span>
																	<span
																		style={{
																			color: "orange",
																		}}
																		className="textSmall"
																	>
																		{
																			step[
																				"1"
																			]
																		}
																	</span>
																	<span
																		style={{
																			color: "red",
																		}}
																		className="textSmall"
																	>
																		{
																			step[
																				"3"
																			]
																		}
																	</span>
																	<span
																		style={{
																			color: "gray",
																		}}
																		className="textSmall"
																	>
																		{
																			step[
																				"0"
																			]
																		}
																	</span>
																</div>
															)}
														</div>
														<div className="w-full flex">
															<div
																className={`w-[50%] ${
																	!(
																		index ==
																			4 &&
																		idx == 2
																	)
																		? "dummyRightBorder"
																		: ""
																}`}
															></div>
															<div
																className={`w-[50%] ${
																	idx == 3
																		? "dummyBottomBorder"
																		: ""
																}`}
															></div>
														</div>
													</>
												)
											)}
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="h-[100%] w-[100%] flex justify-center text-center font-bold items-center text-black text-[2.4vh] textNormal">
								{viewParam
									? viewParam == "manager"
										? "Please select a Manager to see the data"
										: "Please select a Manager and L3 category to see the data"
									: `Please select a Manager / Manager and L3 to see the respective data`}
							</div>
						)}
					</div>
					{selectedFilters?.manager?.length > 0 && (
						<div className="legendWrapper">
							<span style={{ color: "green" }}>
								# Categories Completed
							</span>
							<span style={{ color: "#de8f00" }}>
								# Categories In Progress
							</span>
							<span style={{ color: "#e40000" }}>
								# Categories At Risk
							</span>
							<span style={{ color: "gray" }}>
								# Categories Not Started
							</span>
						</div>
					)}
				</MainContent>
			</div>
			<Modal
				backdrop={true}
				role="alertdialog"
				open={alert}
				onClose={handleAlertClose}
				size="xs"
			>
				<Modal.Body>
					<span className="textNormal">
						Remarks <span className="text-[red]">{`*`}</span>
					</span>
					<Input
						as="textarea"
						rows={3}
						value={comment}
						onChange={handleChange}
						placeholder={`Enter between 10 and 100 characters`}
					/>
					{warning && <span className="textNormal">{warning}</span>}
				</Modal.Body>
				<Modal.Footer>
					<Button
						onClick={handleAlertClose}
						className="modal-close-btn textNormal"
					>
						Cancel
					</Button>
					<Button
						onClick={handleAlertConfirmClick}
						className="modal-yes-btn textNormal"
						disabled={!!warning || !comment}
					>
						Mark as Completed
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

const mapDispatchToProps = (dispatch: any) => ({});
export default connect(null, mapDispatchToProps)(CategoryProgressTracker);
